import './App.css';
import 'react-toastify/dist/ReactToastify.css';

import { AppRouter } from './routes/routes';
import {
  Toast,
  AppContext,
  lazyResources,
  useAwaitFonts,
  usePreloadAssets,
  importantResources,
  JackpotIconTooltip,
  isTutorialActive,
  tutorialResourcesLanding,
} from 'lotto-shared';
import { ToastController } from '@shared/Toasts';

export const App = () => {
  const allFontsLoaded = useAwaitFonts();
  const tutorialActive = isTutorialActive();

  const assetsLoaded = usePreloadAssets(
    importantResources,
    lazyResources,
    tutorialActive ? tutorialResourcesLanding : [],
  );

  if (!allFontsLoaded || !assetsLoaded) return <></>;

  return (
    <AppContext.Provider value={{ isTelegramBot: true }}>
      <AppRouter />
      <Toast />
      <ToastController />
      <JackpotIconTooltip />
    </AppContext.Provider>
  );
};
